"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_PARTNER = exports.DEFAULT_BROKER = exports.DEFAULT_BRAND = void 0;
var DEFAULT_BRAND = exports.DEFAULT_BRAND = 'PETSURE';
var DEFAULT_PARTNER = exports.DEFAULT_PARTNER = 'PINSCOM';
var DEFAULT_BROKER = exports.DEFAULT_BROKER = 'PICA';